import apiClient from '../../../shared/services/apiHelper';
import { getOuId } from '../../../shared/utils/authStorage';

export const checklistService = {
  fetchChecklist: async (taskId, page = 1, limit = 10) => {
    const ouId = getOuId();
    const response = await apiClient.get('/checklist', {
      ouId,
      task_id: taskId,
      page_number: page,
      limit,
    });
    return response.data;
  },

  fetchAnswers: async (taskId, checklistId) => {
    const ouId = getOuId();
    const response = await apiClient.get('/answer', {
      ouId,
      task_id: taskId,
      checklist_id: checklistId,
    });
    return response.data;
  },
};
